module.exports = __webpack_public_path__ + "img/d-ftop-cn.f6fb5ca2.jpg";